import AccessControl from '@gef-ui/cdu-user/components/AccessControl';

import { KMP_DISPLAY_CAMPAIGN_OVERVIEW } from 'features/common/acl/constants';
import Contacts, { Sidebar } from 'pages/Contacts';

import PageLayout from '../components/PageLayout';

/**
 * GEF_KCL-183 Dashboard
 */
const ContactsPage = () => (
	<PageLayout aside={<Sidebar />}>
		<div className="Page-main">
			<AccessControl accessLevel={KMP_DISPLAY_CAMPAIGN_OVERVIEW} showAccessDenied>
				<Contacts />
			</AccessControl>
		</div>
	</PageLayout>
);

export default ContactsPage;
